import React, { useState } from 'react'
import { Text, View } from 'react-native'

import { caption } from '@ui-kit/core/typography'

import RadioCard from './RadioCard/index.native'
import * as styles from './styles'
import type { NativeProps, RadioOptionValue } from './types'

const RadioCardSet = (props: NativeProps): JSX.Element => {
  const [currentValue, setCurrentValue] = useState(props.value)

  const layout = props.layout ?? 'compact'

  const onOptionPress = (newValue: RadioOptionValue) => {
    if (newValue === currentValue) {
      return
    }

    setCurrentValue(newValue)

    if (typeof props.onValueChange === 'function') {
      props.onValueChange(newValue)
    }
  }

  const hasTopTags = props.options.some((option) => option.topTag !== undefined)
  const hasBottomTags = props.options.some((option) => option.bottomTag !== undefined)
  const { container, list } = styles.radioCardSet({
    hasTopTags,
    hasBottomTags,
    layout,
  })

  return (
    <View className={container()}>
      <View className={list()}>
        {props.options
          .filter((option) => !option.hidden)
          .map((option) => (
            <RadioCard
              {...option}
              hasTopTags={hasTopTags}
              hasBottomTags={hasBottomTags}
              testID={`radio-card-${option.value}`}
              onPress={onOptionPress}
              key={String(option.value)}
              layout={option.layout ?? layout}
              isSelected={option.value === props.value}
              isUntouched={props.value === undefined}
              disabled={option.disabled || props.disabled || false}
            />
          ))}
      </View>
      {props.errorMessage ? (
        <Text className={caption({ color: 'uiRed' })}>{props.errorMessage}</Text>
      ) : null}
    </View>
  )
}

export default RadioCardSet
